import type { SpinnerProps } from "@/components/ui/Spinner";
import { twMerge } from "tailwind-merge";
import { Spinner } from "@/components/ui/Spinner";
type LoadingProps = SpinnerProps & {
  testId?: string;
  className?: string;
};
const Loading = ({
  testId,
  className,
  ...props
}: LoadingProps) => {
  return <span data-testid={testId} className={twMerge("flex items-center justify-center", className)} data-sentry-component="Loading" data-sentry-source-file="Loading.tsx">
      <Spinner color="secondary" {...props} data-sentry-element="Spinner" data-sentry-source-file="Loading.tsx" />
    </span>;
};
export { Loading };